import { defineStore, skipHydrate } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

export const useAddressStore = defineStore('address', () => {
  const address = useLocalStorage<string>('address', null);
  return { address: skipHydrate(address) };
});
